import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import DataTable, { type Column } from "../../components/DataTable";
import Badge from "../../components/Badge";
import { useMembersList } from "../../../hooks/useMembersList";
import { useDeleteMember } from "../../../hooks/useDeleteMember";
import { useUpdateMemberStatus } from "../../../hooks/useUpdateMemberStatus";
import type { MemberResponse } from "../../../api/membersApi";

export default function MemberListPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useMembersList();
  const remove = useDeleteMember();
  const status = useUpdateMemberStatus();

  const columns: Column<MemberResponse>[] = [
    {
      key: "user",
      header: "Membre",
      render: (row) => (
        <div>
          <div style={{ fontWeight: 600, color: "var(--ink)" }}>{row.userName ?? row.userId}</div>
          <div style={{ fontSize: 11, color: "var(--ink-faint)" }}>{row.userId}</div>
        </div>
      ),
    },
    { key: "role", header: "Rôle", render: (row) => <Badge tone={row.role === "ADMIN" ? "info" : "neutral"}>{row.role}</Badge> },
    {
      key: "status",
      header: "Statut",
      render: (row) => (
        <Badge tone={row.status === "ACTIVE" ? "success" : row.status === "PENDING" ? "warning" : "danger"}>
          {row.status}
        </Badge>
      ),
    },
    { key: "assigned", header: "Parcours assignés", render: (row) => row.assignedParcoursIds?.length ?? 0 },
    {
      key: "actions",
      header: "",
      render: (row) => (
        <div className="bo-row-end">
          <Button variant="ghost" onClick={() => navigate(`/admin/members/${row.id}/assign`)}>
            Assignations
          </Button>
          {row.status !== "ACTIVE" && (
            <Button variant="ghost" onClick={() => status.mutate({ id: row.id, status: "ACTIVE" })}>
              Activer
            </Button>
          )}
          <Button variant="ghost" onClick={() => window.confirm("Supprimer ce membre ?") && remove.mutate(row.id)}>
            Supprimer
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title="Membres"
        description="Gestion des administrateurs et éditeurs du tenant."
        actions={
          <Button variant="primary" onClick={() => navigate("/admin/members/invite")}>
            + Inviter
          </Button>
        }
      />
      <DataTable rows={data} columns={columns} rowKey={(r) => r.id} loading={isLoading} />
    </div>
  );
}
